<mat-card>
  <dmb-card-header (closeModal)="close()">
    <span i18n="@@Login.password.forgotten.header">Forgotten Password</span>
  </dmb-card-header>
  @if (showForm()) {
    <mat-card-content>
      <p i18n="@@login.password.forgotten.text">
        Please enter your email address or user name associated with your account. The DMB will email instructions on
        how to reset your password.
      </p>
      <dmb-input
        [control]="userInput"
        id="userInput"
        label="email or username"
        i18n-label="@@login.password.forgotten.label">
      </dmb-input>
      @if (sendingError()) {
        <mat-error>There was an error when connecting to the server. Please try again later.</mat-error>
      }
    </mat-card-content>
    <mat-card-actions>
      <dmb-button type="button" (buttonClick)="resetPassword()" [disabled]="!userInput.valid || loading()"
        >OK</dmb-button
      >
    </mat-card-actions>
  } @else {
    <mat-card-content>
      <p i18n="@@login.password.forgotten.success.text">
        If a user account with the given user name exists, we will send an email with further instructions to reset your
        password.
      </p>
    </mat-card-content>
  }
</mat-card>
